import { Component, Inject } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { finalize } from 'rxjs/operators';
import { ClientDocument, SignedDocument } from 'src/app/api/models';
import { SignedDocumentsService } from 'src/app/api/services';

export interface DialogData {
  document: ClientDocument;
  signedDocument?: SignedDocument;
}

@Component({
  selector: 'app-sign-document-request-dialog',
  templateUrl: './sign-document-request-dialog.component.html',
  styleUrls: ['./sign-document-request-dialog.component.scss']
})
export class SignDocumentRequestDialogComponent {
  form: UntypedFormGroup;
  signers: UntypedFormArray;

  constructor(
    public dialogRef: MatDialogRef<SignDocumentRequestDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private signedDocumentsService: SignedDocumentsService,
    private builder: UntypedFormBuilder,
  ) {
    this.form = this.builder.group({
      name: [data.document.name, Validators.required],
      sign_as_inviter: [true, null],
      signers: this.builder.array([this.createSigner()])
    });
  }

  createSigner(): UntypedFormGroup {
    return this.builder.group({
      name: '',
      sms: '',
      email: ''
    });
  }

  addSigner(): void {
    this.signers = this.form.get('signers') as UntypedFormArray;
    this.signers.push(this.createSigner());
  }

  onSend(submitBtn: HTMLButtonElement): void {
    submitBtn.disabled = true;
    const formModel = this.form.value;
    console.log("onSend", formModel);

    this.signedDocumentsService.createSignedDocument({
      body: {
        document_id: this.data.document.id,
        name: formModel.name,
        sign_as_inviter: formModel.sign_as_inviter,
        signers: formModel.signers,
      },
    })
      .pipe(finalize(() => { submitBtn.disabled = false; }))
      .subscribe(signedDoc => {
        console.log("signedDoc", signedDoc);
        this.dialogRef.close(signedDoc);
      })
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
